function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2727 4.8125L9.54545 7.625H11.5909C11.5909 9.95234 9.75682 11.8438 7.5 11.8438C6.81136 11.8438 6.15682 11.668 5.59091 11.3516L4.59545 12.3781C5.43409 12.9266 6.42955 13.25 7.5 13.25C10.5136 13.25 12.9545 10.7328 12.9545 7.625H15L12.2727 4.8125ZM3.40909 7.625C3.40909 5.29766 5.24318 3.40625 7.5 3.40625C8.18864 3.40625 8.84318 3.58203 9.40909 3.89844L10.4045 2.87187C9.56591 2.32344 8.57045 2 7.5 2C4.48636 2 2.04545 4.51719 2.04545 7.625H0L2.72727 10.4375L5.45455 7.625H3.40909Z",
  fill: "#55586F"
});

function SvgConnections(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnections);
export default __webpack_public_path__ + "static/media/connections.52818d84.svg";
export { ForwardRef as ReactComponent };